// extracted by mini-css-extract-plugin
module.exports = {"container":"PricingPage_container__LaGrZ"};